import { ArrowLeftOutlined } from "@ant-design/icons";

const R = {
  ink: "var(--color-ink)",
  textMuted: "var(--color-muted)",
};

export default function BackButton({
  onClick,
  title,
}: {
  onClick: () => void;
  title?: string;
}) {
  return (
    <button
      type="button"
      title={title}
      onClick={onClick}
      style={{
        height: 30,
        width: 30,
        borderRadius: 6,
        background: "transparent",
        border: "none",
        color: R.textMuted,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        transition: "background 120ms, color 120ms",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = "var(--color-shade-1)";
        e.currentTarget.style.color = R.ink;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "transparent";
        e.currentTarget.style.color = R.textMuted;
      }}
    >
      <ArrowLeftOutlined style={{ fontSize: 14 }} />
    </button>
  );
}
